import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

// Actions
import {
  loadAgents,
} from '../../../actions/agent';

// Components
import ModalBase from '../../../common/components/ModalBase';
import Pages from './Pages';

function AddUser() {
  const dispatch = useDispatch();
  const {
    agencies: { records: agencies },
    modals: { addUserOpen: isOpen },
    agents: {
      sortTerm,
      sortInverse,
    },
    theme: { defaultAgentAgency = '' },
  } = useSelector(store => store);

  function close() {
    dispatch({ type: 'CLOSE_MODAL', modal: 'addUserOpen' });
    // Reload entire Agent list for proper placement
    loadAgents({ sort: sortTerm, desc: sortInverse });
  }

  useEffect(() => {
    if (isOpen && defaultAgentAgency) {
      /* eslint-disable arrow-body-style */
      const defaultAgency = agencies.filter((agency) => (agency.name === defaultAgentAgency))[0] || {};
      dispatch({
        type: 'EDIT_ADD_USER',
        valid: true,
        value: Number(defaultAgency.id),
        id: 'agency',
      });
    }
  }, [isOpen]);

  return (
    <ModalBase
      isOpen={isOpen}
      closeModalAction={() => close()}
      staticWidth="96vw"
      hideHeader="true"
      padding="0"
      style={{ overflowX: 'hidden', borderRadius: '1rem' }}
    >
      <div className="px-5 py-3 h4 d-flex justify-content-between align-items-center border-bottom">
        Add User
        <button type="button" className="btn" onClick={() => close()}>
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>
      </div>
      <Pages />
    </ModalBase>
  );
}

export default AddUser;
